import React from 'react';
import { Translate } from 'core/translate';
import { TotalLine } from './Lines';
import { Price } from './Price';
import MathBoxGroup from './MathBoxGroup';

const StandardPriceGroup = ({ pricing, isSummary }) => {
  const { baseMsrp, isSeeDealer } = pricing;

  if (isSeeDealer) {
    if (!isSummary) {
      return null;
    }

    return (
      <MathBoxGroup>
        <TotalLine
          labelKey="standard.price"
          price={
            <Price>
              <Translate value="unknown.price.text" />
            </Price>
          }
        />
      </MathBoxGroup>
    );
  }

  return (
    <MathBoxGroup>
      <TotalLine labelKey="standard.price" value={baseMsrp} />
    </MathBoxGroup>
  );
};

export default StandardPriceGroup;
